import Accordions4i from '../../common/accordions25.js';

const SELECTORS = {
    FOOTER_CONTAINER: ".mainSiteFooter",
    MEDIA_ACCORDION: "mediaSection",
    WORLDWIDE_ACCORDION: "worldwideSection",
};

class Footer4i {
    constructor() {
        this.footerContainer = document.querySelector(SELECTORS.FOOTER_CONTAINER);
        this.mediaAccordion = document.getElementById(SELECTORS.MEDIA_ACCORDION);
        this.worldwideAccordion = document.getElementById(SELECTORS.WORLDWIDE_ACCORDION);
        this.footerAccordions = new Accordions4i();
    }

    init = async () => {
        await this.footerAccordions.init(this.footerContainer);
        this.openCloseAccordions();
        window.addEventListener("resize", this.openCloseAccordions); 
    };

    openCloseAccordions = () => {
        const areOpen = this.mediaAccordion.classList.contains("open") || this.worldwideAccordion.classList.contains("open");
        if (window.innerWidth < 600 && areOpen) {    
            this.footerAccordions.close(this.mediaAccordion);
            this.footerAccordions.close(this.worldwideAccordion);
        } else if(!areOpen) {
            this.footerAccordions.openAll();
        }
    };
}

export default new Footer4i();